export default "__VITE_PUBLIC_ASSET__499cad73__"